import React, { memo, useMemo } from 'react';
import {
  useEngineInstance,
  useEnginePagination,
  UseEnginePaginationSelector,
  Equality
} from '@surveycake/react-logic-engine';
import Subject from 'app/pages/Survey/Subject';
import NextPage from './NextPage';
import { useStyles } from './styles';

function calculateBreadCount(breadcrumb: string[]) {
  const [first, second] = breadcrumb;
  return (first ? 1 : 0) + (second ? 1 : 0);
}

interface PaginationResult {
  list: number[];
  breadcrumbCount: number;
}

const paginationSelector: UseEnginePaginationSelector<
  PaginationResult
> = pagination => ({
  list: pagination.pages[pagination.current],
  breadcrumbCount: calculateBreadCount(pagination.breadcrumb)
});

const paginationEquality: Equality<PaginationResult> = (prev, next) =>
  prev.list === next.list && prev.breadcrumbCount === next.breadcrumbCount;

function Subjects() {
  const engine = useEngineInstance();
  const { multiplePages, singleSubjectPerPage } = useMemo(
    () => ({
      multiplePages: engine.getSurveyData().multiplePages,
      singleSubjectPerPage: engine.isSingleSubjectPerPage()
    }),
    [engine]
  );
  const { list, breadcrumbCount } = useEnginePagination(
    paginationSelector,
    paginationEquality
  );
  const styles = useStyles([singleSubjectPerPage, breadcrumbCount]);

  if (!list) {
    return null;
  }

  return (
    <div className={styles.subjects} aria-label="subjects">
      {list.map(id => (
        <Subject key={id} id={id} />
      ))}
      {multiplePages && <NextPage />}
    </div>
  );
}

export default memo(Subjects);
